import React from 'react';

import {
    Map1,
    Messages,
    ProfileCircle,
    DocumentText,
    Profile,
    Activity,
    Briefcase,
    SearchNormal1,
    Flash,
} from 'iconsax-react';

import LinkButton from '@core/components/linkbutton/LinkButton';

import classes from './CareerTools.module.scss';

// Theme keys map to colour modifiers in the SCSS module.
const COLUMNS = [
    {
        id: 'grow',
        theme: 'orange',
        HeadIcon: Map1,
        title: 'Plan Your Growth',
        subtitle: 'Chart a clear path to your pharma career goals',
        items: [
            {
                id: 'career-paths',
                Icon: Map1,
                label: 'Career Paths',
                detail: 'Follow a structured learning route for your target pharma role',
            },
            {
                id: 'career-coaching',
                Icon: Messages,
                label: 'Career Coaching',
                detail: 'Get expert support for your next career move',
            },
        ],
    },
    {
        id: 'profile',
        theme: 'pink',
        HeadIcon: ProfileCircle,
        title: 'Build Your Profile',
        subtitle: 'Create materials that make your expertise visible',
        items: [
            {
                id: 'resume-builder',
                Icon: DocumentText,
                label: 'Resume Builder',
                detail: 'Create a pharma-focused resume inside Pharmuni',
            },
            {
                id: 'professional-profile',
                Icon: Profile,
                label: 'Professional Profile',
                detail: 'Turn your CV into a shareable career profile',
            },
            {
                id: 'competency-radar',
                Icon: Activity,
                label: 'Career Competency Radar',
                detail: 'See your strengths, gaps, and readiness visually',
            },
        ],
    },
    {
        id: 'jobs',
        theme: 'teal',
        HeadIcon: Briefcase,
        title: 'Find Better-Fit Jobs',
        subtitle: 'Match your skills to opportunities that fit you precisely',
        items: [
            {
                id: 'jobs-platform',
                Icon: SearchNormal1,
                label: 'Jobs Platform',
                detail: 'Explore pharma job opportunities in one place',
            },
            {
                id: 'job-matching',
                Icon: Flash,
                label: 'Radar-Based Job Matching',
                detail: 'Compare your radar with job requirements',
            },
        ],
    },
];

const CareerTools = () => {
    return (
        <div className='container'>
            <section className={classes['tools']}>
                <div className={classes['tools__head']}>
                    <h2>
                        Career Tools That Turn Learning into <span className={classes['tools__accent']}>Action</span>
                    </h2>
                    <p>
                        A connected career toolkit for pharma experts who want to manage their profile, readiness, job search, and expert support in one place.
                    </p>
                </div>

                <div className={classes['tools__grid']}>
                    {COLUMNS.map(({ id, theme, HeadIcon, title, subtitle, items }) => (
                        <article key={id} className={`${classes['tools__card']} ${classes[`tools__card--${theme}`]}`}>
                            <div className={classes['tools__card-head']}>
                                <span className={classes['tools__card-icon']}>
                                    <HeadIcon size={26} variant='Linear' />
                                </span>
                                <h3 className={classes['tools__card-title']}>{title}</h3>
                                <p className={classes['tools__card-subtitle']}>{subtitle}</p>
                            </div>

                            <div className={classes['tools__items']}>
                                {items.map(({ id: itemId, Icon, label, detail }) => (
                                    <div key={itemId} className={classes['tools__item']} tabIndex={0}>
                                        <div className={classes['tools__item-head']}>
                                            <span className={classes['tools__item-icon']}>
                                                <Icon size={22} variant='Linear' />
                                            </span>
                                            <span className={classes['tools__item-label']}>{label}</span>
                                        </div>
                                        <div className={classes['tools__item-detail']}>
                                            <p>{detail}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </article>
                    ))}
                </div>

                <div className={classes['tools__cta']}>
                    <LinkButton kind='secondary-lecture' to='/login' className={classes['tools__cta-btn']}>
                        Create Your Free Career Profile
                    </LinkButton>
                </div>
            </section>
        </div>
    );
};

export default CareerTools;
